import * as React from 'react'
import './OrderFilters.scss'
import moment from 'moment';
import { CHAINTYPES, orderFilterType, orgListItemType, ROLES, selectWalletType, storeType, userType, wallteType, accoutListType } from "../../reducers/types";
import FormControl from "@material-ui/core/FormControl";
import Select from '@material-ui/core/Select';
import { MyInput, Label, MyMenuItem } from "../../components/CustomUIComp/CustomFormElem";
import Grid from "@material-ui/core/Grid";
import { injectIntl, IntlShape } from "react-intl";
import Loadable from "react-loadable";
import 'react-dates/lib/css/_datepicker.css';

interface IProps {
  users: userType[],
  walletList: wallteType[],
  storeList: storeType[],
  orgList: orgListItemType[],
  selectWallet: selectWalletType,
  filters: orderFilterType,
  handleFilterChange: ((filters: orderFilterType) => void),
  onConfirm: (() => void)
  onClear: () => void,
  onExport: () => void,
  chainType: CHAINTYPES,
  role: ROLES,
  intl: IntlShape,
  accoutList: accoutListType[]
}

interface IState {
  focusedInput: string | null
}

const LoadableComponent = Loadable({
  loader: () => import('./OrderDatePicker'),
  loading() { return (<div>loading...</div>) },
});

class OrderFilters extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      focusedInput: null
    }

  }

  handleDateChange = (value: any) => {
    let start = this.props.filters.startDate, end = this.props.filters.endDate
    if (value.startDate) {
      start = moment(value.startDate).format("YYYY-MM-DD")
    }
    if (value.endDate) {
      end = moment(value.endDate).format("YYYY-MM-DD")
    }
    this.props.handleFilterChange({ ...this.props.filters, startDate: start, endDate: end })
    // this.setState({startDate: value.startDate, endDate: value.endDate})
  }
  handleFocuseChange = (value: any) => {
    this.setState({ focusedInput: value })
  }

  getSettleStatus = () => {
    let { intl } = this.props
    return [
      { value: -1, label: intl.formatMessage({ id: 'all' }) },
      { value: 1, label: intl.formatMessage({ id: 'settled' }) },
      { value: 0, label: intl.formatMessage({ id: 'unSettled' }) }
    ]
  }
  isOutsideRange = (day: any) => {
    return day.isAfter()
  }

  public render() {
    const settlementOptions = this.getSettleStatus()
    let { filters, intl } = this.props
    return (
      <div className="OrderFilters">
        <Grid container spacing={2}>
          <Grid item>
            <LoadableComponent filters={filters}
              handleDateChange={this.handleDateChange}
              focusedInput={this.state.focusedInput}
              handleFocuseChange={this.handleFocuseChange} />
          </Grid>
          <Grid item>
            <div className="filterItem">
              <FormControl className="formControl">
                <Label shrink htmlFor="order-no-input">{intl.formatMessage({ id: 'orderNo' })}</Label>
                <MyInput border="none" width={130} value={filters.orderNo} labelmargin={18}
                  id="order-no-input"
                  name="orderNo"
                  onChange={(e: any) => this.props.handleFilterChange({
                    ...filters,
                    orderNo: e.target.value
                  })} />
              </FormControl>
            </div>
          </Grid>
          <Grid item>
            <div className="filterItem">
              <FormControl className="formControl">
                <Label shrink htmlFor="settle-status-select">
                  {intl.formatMessage({ id: 'settlementStatus' })}
                </Label>
                <Select
                  value={filters.settleStatus}
                  onChange={(event: React.ChangeEvent<{ name?: string; value: any }>) => this.props.handleFilterChange({
                    ...filters,
                    settleStatus: event.target.value
                  })}
                  input={<MyInput width={130} labelmargin={18} border="none" id="settle-status-select" name="settleStatus" />}
                >
                  {
                    settlementOptions.map((settleStatus, i) => {
                      return <MyMenuItem key={`settle-statues-${settleStatus.value}`}
                        value={settleStatus.value}>{settleStatus.label}</MyMenuItem>
                    })
                  }
                </Select>

              </FormControl>
            </div>
          </Grid>
          <Grid item>
            <div className="filterItem">
              <FormControl className="formControl">
                <Label shrink htmlFor="cashier-select">
                  {intl.formatMessage({ id: 'CASHIER' })}
                </Label>
                <Select
                  displayEmpty
                  value={filters.cashierNo}
                  onChange={(event: React.ChangeEvent<{ name?: string; value: any }>) => this.props.handleFilterChange({
                    ...filters,
                    cashierNo: String(event.target.value)
                  })}
                  input={<MyInput width={130} labelmargin={18} border="none" id="cashier-select" name="cashierNo" />}
                >
                  <MyMenuItem key={`cashier-all`}
                    value={''}>{intl.formatMessage({ id: 'all' })}</MyMenuItem>
                  {
                    this.props.users.map((user, i) => {
                      return <MyMenuItem key={`cashier-${user.cashierNo}`}
                        value={user.cashierNo}>{user.name || user.loginNo}</MyMenuItem>
                    })
                  }
                </Select>
              </FormControl>
            </div>
          </Grid>
          <Grid item>
            <div className="filterItem">
              <FormControl className="formControl">
                <Label shrink htmlFor="org-select">
                  {intl.formatMessage({ id: 'acquirer' }) || '收单机构'}
                </Label>
                <Select
                  displayEmpty
                  value={filters.payOrg}
                  onChange={(event: React.ChangeEvent<{ name?: string; value: any }>) => this.props.handleFilterChange({
                    ...filters,
                    payOrg: event.target.value
                  })}
                  input={<MyInput width={130} labelmargin={18} border="none" id="org-select" name="payOrg" />}
                >
                  <MyMenuItem key={`org-all`}
                    value={''}>{intl.formatMessage({ id: 'all' })}</MyMenuItem>
                  {
                    this.props.orgList.map((org, i) => {
                      return <MyMenuItem key={`org-${org.payOrg}`}
                        value={org.payOrg}>{org.name}</MyMenuItem>
                    })
                  }
                </Select>
              </FormControl>
            </div>
          </Grid>
          <Grid item>
            <div className="filterItem">
              <FormControl className="formControl">
                <Label shrink htmlFor="wallet-select">
                  {intl.formatMessage({ id: 'payType' })}
                </Label>
                <Select
                  displayEmpty
                  value={filters.wallet}
                  onChange={(event: React.ChangeEvent<{ name?: string; value: any }>) => this.props.handleFilterChange({
                    ...filters,
                    wallet: event.target.value
                  })}
                  input={<MyInput width={130} border="none" labelmargin={18} id="wallet-select" name="wallet" />}
                >
                  <MyMenuItem key={`wallet-all`}
                    value={''}>{intl.formatMessage({ id: 'all' })}</MyMenuItem>
                  {
                    Object.keys(this.props.selectWallet).map((walletKey) => {
                      const wallet = this.props.selectWallet[walletKey];
                      return <MyMenuItem key={`wallet-${wallet.wallet}`}
                        value={wallet.wallet}>{wallet.name || wallet.wallet}</MyMenuItem>
                    })
                  }

                </Select>
              </FormControl>
            </div>
          </Grid>
          <Grid item>
            <div className="filterItem">
              <FormControl className="formControl">
                <Label shrink htmlFor="wallet-select">
                  {intl.formatMessage({ id: 'payCurrency' })}
                </Label>
                <Select
                  displayEmpty
                  value={filters.currency}
                  onChange={(event: React.ChangeEvent<{ name?: string; value: any }>) => this.props.handleFilterChange({
                    ...filters,
                    currency: event.target.value
                  })}
                  input={<MyInput width={130} border="none" labelmargin={18} id="currency-select" name="currency" />}
                >
                  <MyMenuItem key={`currency-all`}
                    value={''}>{intl.formatMessage({ id: 'all' })}</MyMenuItem>
                  {
                    this.props.accoutList.map((opt, i) => {
                      return <MyMenuItem key={`currency-${opt.id}`}
                        value={opt.currency}>{opt.currency}</MyMenuItem>
                    })
                  }

                </Select>
              </FormControl>
            </div>
          </Grid>
        </Grid>
        <div className="buttons">
          <button className="primaryButton"
            onClick={this.props.onConfirm}>{intl.formatMessage({ id: 'query' })}</button>
          <button className="whiteButton"
            onClick={this.props.onExport}>{intl.formatMessage({ id: 'export' })}</button>
          <button className="whiteButton"
            onClick={this.props.onClear}>{intl.formatMessage({ id: 'clear' })}</button>
        </div>
      </div>
    );
  }
}

export default injectIntl(OrderFilters)